'use strict';
import $ from 'jquery';

export default class M1 {
    static init() {
        $('.module-m1').each((index, el) => {
            new M1($(el));
        });
    }

    constructor($el) {
        const self = this;
        this.el = $el;
        this.el.find('[data-lottie-file]').on('lottie-playing', () => {
            self.el.addClass("lottie-playing");
        });
    }
}